import React from 'react';
import { Check } from 'lucide-react';

interface ProgressStepsProps {
  currentStep: number;
}

export const ProgressSteps: React.FC<ProgressStepsProps> = ({ currentStep }) => {
  const steps = [
    { number: 1, label: 'Record' },
    { number: 2, label: 'Customize' },
    { number: 3, label: 'Review' }
  ];

  return (
    <div className="relative">
      <div className="absolute inset-0 flex items-center" aria-hidden="true">
        <div className="h-0.5 w-full bg-gray-200" />
      </div>
      <ul className="relative flex justify-between">
        {steps.map((step) => (
          <li key={step.number} className="flex items-center">
            <div
              className={`relative flex h-8 w-8 items-center justify-center rounded-full ${
                step.number < currentStep
                  ? 'bg-green-600'
                  : step.number === currentStep
                  ? 'bg-red-600'
                  : 'bg-gray-300'
              }`}
            >
              {step.number < currentStep ? (
                <Check className="h-5 w-5 text-white" />
              ) : (
                <span className="text-white text-sm">{step.number}</span>
              )}
            </div>
            <span className="ml-2 text-sm font-medium text-gray-900">
              {step.label}
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
};